module.exports = content_switcher;